import axios from "axios";

const talentApi = axios.create({
    baseURL: process.env.REACT_APP_TALENT_API_URL,
    headers: {
        token: process.env.REACT_APP_TALENT_API_KEY
    },
});

export default talentApi;
